import React from "react";
interface ILoadingProps {
  variant?: "small" | "normal";
}
const ProductCardLoading: React.FC<ILoadingProps> = ({ variant }) => {
  if (variant === "small")
    return (
      <div className="rounded-md drop-shadow-md    ">
        <div className="h-40 w-40 rounded-md loading mx-auto my-2" />
        <div className="h-6 w-[60%] rounded-md loading mx-auto my-2" />
      </div>
    );
  return (
    <div className="shadow p-5 animate-pulse  bg-white text-center relative before:absolute before:bottom-0 before:left-0 before:w-0 before:h-1 hover:before:w-full   ">
      <div className=" mb-2 font-bold h-8 mx-auto w-64 rounded-md loading" />
      <div className="h-[200px] w-full loading" />

      <div className="loading w-full h-4 rounded-md my-2" />
      <div className="loading w-full h-4 rounded-md my-2" />
      <div className="loading w-full h-4 rounded-md my-2" />

      <div className="loading rounded-lg h-10 w-20 mx-auto" />
    </div>
  );
};

export default ProductCardLoading;
